
import { supabase } from '@/lib/supabase'
import { addUserToOrganization } from './memberUtils'

/**
 * Gestion des erreurs lors de la création d'organisation
 */
export async function handleOrganizationCreationError(userId: string, metadata: any, subscription_plan_id: string | undefined) {
  try {
    // Check if organization already exists for this user
    const { data: existingOrgs, error: checkError } = await supabase
      .from('organizations')
      .select('id')
      .eq('owner_id', userId)
      .maybeSingle();
      
    if (existingOrgs?.id) {
      console.log('L\'utilisateur a déjà une organisation, tentative d\'ajout comme membre');
      await addUserToOrganization(existingOrgs.id, userId, subscription_plan_id);
      return;
    }
    
    // Fallback: Try RPC with alternative parameters
    console.log('Tentative d\'appel RPC alternatif');
    const { data: altOrgId, error: altOrgError } = await supabase.rpc(
      'manually_create_organization',
      { 
        p_user_id: userId,
        org_name: metadata.organization || 'Nouvelle Organisation',
        plan_name: 'standard' // Fallback to standard plan
      }
    );
    
    if (!altOrgError && altOrgId) {
      console.log('Organisation créée avec succès via RPC alternatif:', altOrgId);
      await addUserToOrganization(altOrgId, userId, subscription_plan_id);
      return;
    }
    
    // Last resort: Direct insertion if all RPC approaches fail
    console.log('Tentative d\'insertion directe dans la table organizations');
    
    // Get max users and profiles based on plan
    const planName = metadata.plan || 'enterprise';
    const maxUsers = planName === 'standard' ? 3 : planName === 'professional' ? 5 : 10;
    const maxProfiles = planName === 'standard' ? 10 : planName === 'professional' ? 20 : 30;
    
    const orgInsertData: Record<string, any> = { 
      name: metadata.organization, 
      owner_id: userId, 
      plan: planName,
      max_users: maxUsers,
      max_profiles: maxProfiles,
      current_users: 1, // Start with 1 user (the owner)
      current_profiles: 0
    };
    
    // Add subscription_plan_id if available
    if (subscription_plan_id) {
      orgInsertData['subscription_plan_id'] = subscription_plan_id;
    }
    
    console.log('Données d\'insertion de l\'organisation:', orgInsertData);
    
    const { data: directOrgData, error: directOrgError } = await supabase
      .from('organizations')
      .insert([orgInsertData])
      .select()
      .single();
      
    if (directOrgError) {
      console.error('Erreur lors de l\'insertion directe de l\'organisation:', directOrgError);
    } else if (directOrgData) {
      console.log('Organisation créée directement avec succès:', directOrgData);
      
      // Add user as organization owner using secure RPC function
      await addUserToOrganization(directOrgData.id, userId, subscription_plan_id);
    }
  } catch (error) {
    console.error('Exception dans handleOrganizationCreationError:', error);
  }
}
